import { useTranslation } from '@ecomm/i18n'
import { ComparisonCell } from '../ComparisonCell'
import { ComparisonRow } from '../ComparisonRow'

export function RowElevatedSupportBusiness() {
  const { t } = useTranslation('maps')

  return (
    <ComparisonRow
      title={t('feature-title.elevated-support-business')}
      description={t('feature-description.elevated-support-business')}
    >
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
    </ComparisonRow>
  )
}
